import {
  createSlice,
  isFulfilled,
  isPending,
  isRejected,
} from '@reduxjs/toolkit';
// STORE
import { RootState } from '..';

const ignoredLoaderPaths: string[] = [
  'questionTag/list',
  '/admin/users/list-for-dropdown',
  '/admin/saving/courses/updateOne',
  '/admin/saving/sections/update',
];

const getTypePrefix = (type: string): string => {
  let typePrefix = '';
  const pathArr = type.split('/');
  pathArr.splice(pathArr.length - 1, 1);
  pathArr.forEach((path, index) => {
    if (index === 0) {
      typePrefix += path;
    } else {
      typePrefix += `/${path}`;
    }
  });
  return typePrefix;
};

export interface ILoaderState {
  loaders: string[];
}

const initialState: ILoaderState = {
  loaders: [],
};

export const LoaderSlice = createSlice({
  name: 'loader',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addMatcher(isPending, (state, action) => {
      const typePrefix = getTypePrefix(action.type);
      const isPathIgnored = ignoredLoaderPaths.includes(typePrefix);
      if (typePrefix && !isPathIgnored) {
        state.loaders.push(typePrefix);
      }
    });
    builder.addMatcher(isRejected, (state, action) => {
      const typePrefix = getTypePrefix(action.type);
      const isPathIgnored = ignoredLoaderPaths.includes(typePrefix);
      if (typePrefix && !isPathIgnored) {
        const newLoaders = state.loaders.filter((item) => item !== typePrefix);
        state.loaders = newLoaders;
      }
    });
    builder.addMatcher(isFulfilled, (state, action) => {
      const typePrefix = getTypePrefix(action.type);
      const isPathIgnored = ignoredLoaderPaths.includes(typePrefix);
      if (typePrefix && !isPathIgnored) {
        const newLoaders = state.loaders.filter((item) => item !== typePrefix);
        state.loaders = newLoaders;
      }
    });
  },
});

export const getLoaderState = (state: RootState): RootState['loader'] =>
  state.loader;

export const getIsLoading = (state: RootState): boolean =>
  state.loader.loaders.length > 0;

export default LoaderSlice.reducer;
